import React from 'react';

import uuid from 'uuid';

import { StyledGoogleAdsMetrics } from './style/StyledGoogleAdsMetrics';

import DynamicComponent from '../../DynamicComponent';

const AdsMetrics = ({ data, channel }) => (
	<StyledGoogleAdsMetrics channel={channel}>
		<section>
			<h2>{data.title}</h2>

			<p className="description">
				{data.content.text}
			</p>

			{data.charts.map(chart => (
				<DynamicComponent
					tag={chart.type}
					data={chart.data}
					captions={chart.captions}
					alias={chart.alias}
					title={chart.title}
					channel={channel}
					key={uuid.v4()}
				/>

			))}
		</section>
	</StyledGoogleAdsMetrics>
);

export default AdsMetrics;
